const DROPZONE_ACCEPTED_FORMATS = 'image/jpeg,image/png,image/webp'

export {
    DROPZONE_ACCEPTED_FORMATS,
}